import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  queryStringTypeName,
  pleaseConnectText,
  continueShopping,
  itemDeletedSuccess,
  itemDeletedFailed,
  itemSavedSuccess,
  itemSavedFailed,
  itemUnSavedSuccess,
  itemUnSavedFailed,
  itemDeletedSavedSuccess,
  itemDeletedSavedFailed,
  removeFromCartCancel,
  seeProduct,
  itemChangeQuantityFailed,
  singleOutOfStock
} = translate({
  "queryStringTypeName": "basket",
  "continueShopping": "Continue shopping",
  "pleaseConnectText": "Login to access your basket",
  "itemDeletedSuccess": "Bingo! The product has been successfully deleted",
  "itemDeletedFailed": "Ah, there's been a little error - the product has not successfully been deleted",
  "itemSavedSuccess": "This product has been carefully put aside! You can find it in the 'Saved' tab, and you will be able to add it back to your order at any time by clicking on 'Add to basket'. Easy, right?",
  "itemSavedFailed": "Ah, there's been a little error - the product has not been saved",
  "itemUnSavedSuccess": "Perfect - the product that had been saved has now successfully been added to your basket",
  "itemUnSavedFailed": "Ah, there's been a little error - the product has not successfully been added to your basket",
  "removeFromCartCancel": "Cancel",
  "itemDeletedSavedSuccess": "All good, the product has successfully been deleted",
  "itemDeletedSavedFailed": "Ah, there's been a little error - the product has not successfully been deleted",
  "seeProduct": "See product",
  "itemChangeQuantityFailed": "There was an error when trying to modify the product quantity.",
  "singleOutOfStock": "Product out of stock"
});
export const refreshPage = translateFormatter<{
  span: RichTextFormatter;
}>("Failed to load page. Please try again later or <span>refresh page.</span>", undefined, undefined, "en");
export const outOfStock = translateFormatter("{count, plural, =1 {{count} product out of stock} other {{count} products out of stock}}", undefined, undefined, "en");
export const productTitle = translateFormatter<{
  nbProducts: number;
}>("Items in your basket", undefined, undefined, "en");